import encryptServer from '../request/encryptRequest';

// 发货列表(分页)
export const queryPage = (data = {}) => {
  return encryptServer.post('/xiaozi-saas/wireless/sale/delivery/pageList', data);
};

// 发货统计
export const queryStateInfo = (data = {}) => {
  return encryptServer.post('/xiaozi-saas/wireless/sale/delivery/count', data);
};

// 发货单详情(新)
export const deliveryDetail = (data = {}) => {
  return encryptServer.post('/xiaozi-saas/wireless/sale/delivery/detail', data);
};

// 快递单详情
export const queryKuaiDi100Detail = (data = {}) => {
  return encryptServer.post('/xiaozi-saas/wireless/kuaiDi100Record/detail', data);
};
